<template>
	<div>
		<el-container>
			<div class="index_header" id="Head">
				<div class="header_back">
					<img src="../assets/index/indexLogo@2x.png" class="index_logo" />
					<div style="display: flex;align-items: center;margin-right: 1.23rem;">
						<div class="index_phone"><i class="el-icon-phone icon-left"></i>  400-015-5987</div>
						<div class="index_phone"><i class="el-icon-phone icon-left"></i>  0931-8800321</div>
						<template v-if="hasLogin">
							<el-dropdown>
								<div class="index_user">
									<img v-if="userInfo.avatar" :src="userInfo.avatar" class="index_userHead" />
									<img v-else src="../assets/index/head.png" class="index_userHead" />
									<span class="index_userbox" @click="goPersonal">{{userInfo.nick_name}}&nbsp;&nbsp;|&nbsp;&nbsp;</span>
									<img src="../assets/index/message.png" style="width: 0.12rem;height: 0.12rem;margin-right: 0.04rem;" />
									<div style="color: #134f97;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 400;
									line-height: normal;cursor: pointer;" @click="goMessage">
										我的消息({{unreadCount}})
									</div>
								</div>
							  <el-dropdown-menu slot="dropdown">
								<el-dropdown-item>
							      <span style="display:block;" @click="getModify">修改密码</span>
							    </el-dropdown-item>
							    <el-dropdown-item>
							      <span style="display:block;" @click="logout">退出登录</span>
							    </el-dropdown-item>
							  </el-dropdown-menu>
							</el-dropdown>
						</template>
						<template v-else>
							<!-- <img src="../assets/index/head.png" class="index_userHead" /> -->
							<div class="index_userName" @click="chooseIndex('login','login')">登录</div>
							<div class="index_userName" @click="chooseIndex('login','register')">注册</div>
						</template>
					</div>
				</div>
				<div class="head_box">
					<div class="index_title" :class="index == 'home' ? 'index_title_active' : ''" @click="chooseIndex('home')">
						首页
					</div>
					<div class="index_title" :class="index == 'class' ? 'index_title_active' : ''" @click="chooseIndex('class')">
						公需课程
					</div>
					<div class="index_title" :class="index == 'learnCourses' ? 'index_title_active' : ''" @click="chooseIndex('learnCourses')">
						专业课程
					</div>
					<div class="index_title" :class="index == 'training' ? 'index_title_active' : ''" @click="chooseIndex('training')">
						培训信息
					</div>
					<div class="index_title" :class="index == 'personnl' ? 'index_title_active' : ''" @click="chooseIndex('personnl')">
						个人中心
					</div>
				</div>
			</div>
			<el-main class="index_main">
				<template v-if="index == 'home'">
					<Home @fatherFunction = "chooseIndex"></Home>
				</template>
				<template v-if="index == 'training'">
					<Training></Training>
				</template>
				<template v-if="index == 'class'">
					<ClassList></ClassList>
				</template>
				<template v-if="index == 'learnCourses'">
					<LearnCourses></LearnCourses>
				</template>
				<template v-if="index == 'personnl'">
					<Personnl ref="myPersonnl" @updateuser="updateuser"></Personnl>
				</template>
				<template v-if="index == 'login'">
					<Login ref="login" @fatherFunction = "chooseIndex" :modifyIndex="modifyIndex"></Login>
				</template>
				<div class="scollTop" id="imgscoll" v-show="isShowimg === true">
					<img src="../assets/index/top.png" @click="goTop"/>
				</div>
				<div class="scollTop_btm" v-if="(index == 'class' || index == 'learnCourses') && hasLogin" @click="goBtmClass()">
					<div class="scollTop_btm_t" v-if="index == 'class'">
						<img src="../assets/index/Vector2.png"/>
						已选公需学时:<span style="margin-left: 0.1rem;">{{`${leftForm.selecteHours1}/${leftForm.publicCredit}`}}</span>
					</div>
					<div class="scollTop_btm_t" v-if="index == 'learnCourses'">
						<img src="../assets/index/Vector1.png" @click="goTop"/>
						已选专业学时:<span style="margin-left: 0.1rem;">{{`${leftForm.selecteHours2}/${leftForm.professionalCredit}`}}</span>
					</div>
					
				</div>
				<div class="class_box" v-if="clasShow">
					<div class="title_box">已选课程表</div>
					<div class="class_cont">
						<div class="class_item" v-for="(item,index) in xfdataList" :key="item.id">
							<div class="item_num">{{ index + 1}}</div>
							<div class="item_text">{{ getTexttitle(item) }}</div>
							<div class="item_xs">{{ getTextxs(item) }}</div>
							<div class="btn_box">
								<i class="el-icon-delete" @click="getRemoveClass(item.id)" style="width:0.2rem;height:0.2rem;display: flex;align-items: center;cursor: pointer;"></i>
							</div>
							
						</div>
					</div>
					<div class="class_btn" v-if="xfdataList.length > 0">
							<div class="btn_right" @click="goPay">支付</div>
						</div>
				</div>
			</el-main>
			<el-footer style="padding: 0;height: auto;">
				<div class="index_foot">
					<div>
					<div class="index_foot_con">
						<div>版权所有：甘肃省教育厅基础教育课程教材中心</div>
						<div class="index_foot_con_unline"><img src="../assets/index/badge.png" style="width: 0.24rem;height: 0.24rem;margin-right: 0.04rem;"/>
						甘公网安备62010202000518号</div>
					</div>
					<div class="index_foot_con">
						<div>联系地址:兰州市城关区雁宁路399号</div>
						<div>邮编：730010</div>
						<div>联系电话：0931-8583449</div>
					</div>
					<div class="index_foot_con">
						<div>Copyright@https://w.gsctc.cn all rights reserved</div>
						<div>工信部案号:陇ICP备17004611号-2</div>
					</div>
					<!-- <div class="index_foot_nl">
						<img src="../assets/index/erweima.png" class="index_foot_ewm"/>
						<div class="index_foot_nl_text">
							微信公众号
						</div>
					</div> -->
					</div>
				</div>
			</el-footer>
			
		</el-container>
		<el-dialog title="扫码支付" :visible.sync="dialogFormVisible" width="30%" :before-close="closeDialog">
			<payment
			:paymentUrl="paymentUrl"
			:status="paymentStatus"
			@refresh="onRefresh"
			/>
		</el-dialog>
	</div>
</template>

<script>
	import Home from './home.vue'
	import ClassList from './classList.vue'
	import LearnCourses from './learnCourses.vue'
	import Training from './training.vue'
	import Personnl from './personnl.vue'
	import Login from './login.vue'
	import { Message } from 'element-ui';
	import md5 from 'js-md5'
	import payment from '../components/payment.vue'
	export default{
		components:{
			Home,
			ClassList,
			LearnCourses,
			Training,
			Personnl,
			Login,
			payment
		},
		data() {
			return {
				index: 'home',
				hasLogin:false,
				userInfo:'',
				isShowimg: false,
				date:0,
				unreadCount: 0,
				leftForm:{
					selecteHours1:0,//已选共需课程学时
					selecteHours2:0,// 已选专业课程学时
					publicCredit:0,//公需学时
					professionalCredit:0//专业学时
				},
				xfdataList:[],
				clasShow:false,
				modifyIndex:'',
				dialogFormVisible:false,
				paymentUrl: '',
				paymentStatus: 'pending', // pending, success, failed
				orderId: '',
				pollTimer: null,
				// 记录点击支付操作
				isPaying: false,
			}
		},
		watch:{
			'$store.state.leftForm':{
				handler(newDate){
					console.log('走这index',newDate);
					this.leftForm = newDate
				}
			},
			index:{
				handler(newDate,oldDate){
					if(newDate!==oldDate){
						this.clasShow = false
					}
				}
			}
		},
		created() {
			this.getBtnLeft()
		},
		mounted() {
			//获取登录用户信息
			this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
			if(this.userInfo != null && this.userInfo != undefined){
				this.hasLogin = true;
				this.getUnread();
			}
			this.index = this.$route.query.type;
			if(this.index == undefined){
				this.index = 'home'
			}
			console.log(this.index)
			sessionStorage.setItem('dingbu',this.index);
			window.addEventListener('scroll', this.handleScroll)
			this.getscroll()
		},
		destroyed() {
		    document.removeEventListener('scroll', this.handleScroll)
		    document.body.scrollTop = document.documentElement.scrollTop = 0
			if(this.pollTimer){
				clearInterval(this.pollTimer)
			}
		},
		methods:{
			getscroll(){
				let Head = document.getElementById('Head')
				window.onscroll = ()=>{
					// 获取滚动距离
					let top = document.documentElement.scrollTop || document.body.scrollTop;
					if (top != 0) {
						Head.style = "position: fixed;top: 0;width:100%;z-index:9999"
					}else{
						Head.style = "position: static;"
					}
				}
			},
			updateuser(row){
				this.userInfo = row
			},
			getBtnLeft(){
				this.$get('/personal-center/v1/personal-subject/credit_hour',{year:''})
					.then(res => {
						if(res.code == '200'){
							this.leftForm = {
								selecteHours1:res.data.selectedCommonCurseHours?res.data.selectedCommonCurseHours:0,//已选公需课程学时
								selecteHours2:res.data.selectedProfessionCurseHours?res.data.selectedProfessionCurseHours:0,// 已选专业课程学时
								publicCredit:res.data.publicCredit?res.data.publicCredit:0,//公需学分
								professionalCredit:res.data.professionalCredit?res.data.professionalCredit:0//专业学分
							}
						}else{
							this.$message({
								message: res.msg,
							});
						}
					})
			},
			chooseIndex(type,value){
				//判断 只有登录才能打开个人中心
				if(type == 'personnl'){
					if(this.hasLogin){
						this.index = type;
					}else{
						this.index = 'login';
						this.modifyIndex = 'login'
					}
				}else{
					this.index = type;
					if(value == 'login'){
						this.modifyIndex = 'login'
					}else if(value == 'register'){
						this.modifyIndex = 'register'
					}
				}
				//获取登录用户信息
				this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
				if(this.userInfo != null && this.userInfo != undefined){
					this.hasLogin = true;
					this.getUnread();
				}
				sessionStorage.setItem('dingbu',this.index);
				if(type == 'class' || type == 'learnCourses'){
					this.getBtnLeft()
				}
			},
			goTop() {
				// 回到顶部
			  document.body.scrollTop = document.documentElement.scrollTop = 0
			  this.isShowimg = false
			},
			goBtmClass(){
				this.clasShow = !this.clasShow
				if(this.clasShow){
					if(this.index == 'class'){
						this.getuserclasslist(0)
					}else if(this.index == 'learnCourses'){
						this.getuserclasslist(1)
					}
				}
			},
			//获取已选课程表
			getuserclasslist(val){
				this.$post('/user/BladeUserCourseSelection/get-user-class-list',{belongType:val})
				.then((res) => {
					if(res.code == '200'){
						this.xfdataList = res.data
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			//删除已选课程
			getRemoveClass(id){
				let obj = this.userInfo
				this.$post('/user/BladeUserCourseSelection/user-remove-class',{classObjectCourseId:id,userId:obj.user_id?obj.user_id:''})
				.then((res) => {
					if(res.code == '200'){
						if(this.index == 'class'){
							this.getuserclasslist(0)
						}else if(this.index == 'learnCourses'){
							this.getuserclasslist(1)
						}
						this.getBtnLeft()
						this.$message({
						  message: res.msg,
						  type:'success'
						});
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			getTexttitle(row){
				if(this.index == 'class'){
					return row.subjectName
				}else if(this.index == 'learnCourses'){
					return row.courseName
				}
			},
			getTextxs(row){
				if(this.index == 'class'){
					return row.creditHour
				}else if(this.index == 'learnCourses'){
					return row.credit
				}
			},
			//获取未读消息数量
			getUnread(){
				this.$get('/blade-desk/notice/unread/count',{})
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.unreadCount = res.data
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			goPersonal(){
				this.chooseIndex('personnl');
				setTimeout(() => {
					this.$refs.myPersonnl.choose('MyCourse');
				}, 100);
			},
			goMessage(){
				this.chooseIndex('personnl');
				setTimeout(() => {
					this.$refs.myPersonnl.choose('SystemMessages');
				}, 100);
			},
			handleScroll(e) {
			  // 滚动操作监听
			  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			  let offsetTop = 0
			  try {
				offsetTop = document.querySelector('.index_main').offsetTop
			  } catch (e) {
				offsetTop = 0
			  }
			  if (scrollTop > offsetTop) {
				if (scrollTop > 500) {
				  this.isShowimg = true
				} else {
				  this.isShowimg = false
				}
			  } else {
				this.isShowimg = false
			  }
			},
			logout(){
				this.$store.dispatch('userLogout')
				this.hasLogin = this.$store.state.hasLogin;
				this.modifyIndex = 'login'
				this.chooseIndex('home');
			},
			getModify(){
				this.index = 'login'
				this.modifyIndex = 'modify'
			},
			// 扫码支付
			goPay(){
				this.isPaying = true
				if(this.xfdataList.length == 0){
					this.$message({
						message: '请选择课程',
						type: 'warning'
					});
					return false;
				}
				let params = this.xfdataList.map(item=>{
					return {
						userId:this.userInfo.user_id,
						classObjectCourseId:item.id,
						belongType:this.index == 'class'?0:1,
					}
				})
				this.dialogFormVisible = true;
				this.$post('/user/BladeUserCourseSelection/user-pay-class',params).then(res=>{
					if(res.code == '200'){
						this.paymentUrl = res.data.url;
						if(this.isPaying && res.data){
							console.log('开始轮询支付结果接口',res)
						// 每隔3秒轮询支付结果接口
						this.pollTimer = setInterval(() => {
							this.$get('/blade-pay/order/checkOrderStatus',{orderNo:res.data.order.orderNo}).then(result => {
								if(result.code == 200 && result.data == true){
									this.paymentStatus = 'success'
									this.closeDialog()
									if(this.index == 'class'){
										this.getuserclasslist(0)
									}else if(this.index == 'learnCourses'){
										this.getuserclasslist(1)
									}
									this.getBtnLeft()
									this.$message({
										type:'success',
										message: '支付成功'
									})
								}
							})
						},3000)
					}
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
				})
			},
			closeDialog(){
				this.dialogFormVisible = false;
				this.paymentUrl = '';
				this.paymentStatus = 'pending';
				this.orderId = '';
				this.isPaying = false;
				if(this.pollTimer){
					clearInterval(this.pollTimer)
				}
			},
			onRefresh(){
				this.goPay()
			},
		},
	}
</script>

<style scoped lang="less">
// /deep/ .el-dialog__header {
//   padding: 0;
// }
// /deep/ .el-dialog__body {
//   padding: 0;
// }
.index_header {
  height: 1.56rem;
  background: #ffffff;
}
.header_back{
	width: 100%;
	height: 0.9rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-image: url('../assets/index/headerBack.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
  }
.index_logo {
  width: 4.47rem;
  height: 0.5rem;
	margin-left: 1.2rem;
}
.index_phone{
	color: #134F97;
	margin-right: 0.5rem;
	font-size: 0.2rem;
	.icon-left {
		display: inline-block;
		transform: scaleX(-1);
	}

}

.head_box{
	width: 100%;
	height: 0.70rem;
	background: #134F97;
	display: flex;
	justify-content: center;
	z-index: 9999999;
}
.index_title {
  width: 2.40rem;
  height: 0.70rem;
  line-height: 0.70rem;
  text-align: center;
  font-size: 0.25rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}
.index_title:hover {
	width: 2.40rem;
	height: 0.70rem;
	/* background: #0F81D3; */
}
.index_title_active {
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ffffff;
	background: #0F81D3;
}
.index_user {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.index_userHead {
  width: 0.33rem;
  height: 0.33rem;
  border-radius: 50%;
  margin-right: 0.08rem;
}
.index_userName {
	width: 0.81rem;
	height: 0.3rem;
	line-height: 0.3rem;
	text-align: center;
	border-radius: 0.15rem;
	border: 1px solid #1153A2;
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #134f97;
  cursor: pointer;
  margin-right: 0.1rem;
}
.index_userbox{
	font-size: 0.14rem;
	font-family: PingFang SC, PingFang SC-Regular;
	font-weight: 400;
	color: #134f97;
	cursor: pointer;
}
.index_userDown {
  width: 0.08rem;
  height: 0.03rem;
  margin-left: 0.08rem;
}
.index_main {
  background: linear-gradient(180deg, #f8f8f7, #ffffff);
  padding: 0;
  min-height: calc(100vh - 3.36rem);
}
.index_foot {
  height: 2.29rem;
	padding: 0 1.2rem;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.24rem;
	background-image: url('../assets/index/footBack.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
}
.index_foot_title {
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #ffffff;
}
.index_foot_con {
  font-size: 0.14rem;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
	height: 0.4rem;
	gap: 0.1rem;
	display: flex;
	flex-direction: row;
	justify-content: center;
}
.index_foot_con_unline {
  font-size: 0.14rem;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  color: #ffffff;
  display: flex;
}
.index_foot_nl {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.index_foot_nl_text {
  color: #ffffff;
	font-family: "Alibaba PuHuiTi";
	font-size: 0.12rem;
	font-weight: 400;
  margin-top: 0.04rem;
}
.index_qikan {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.index_foot_ewm {
  width: 0.82rem;
  height: 0.82rem;
}
.index_foot_down {
  opacity: 0.8;
  font-size: 0.10rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  margin-top: 0.04rem;
}
.login_con {
  padding: 0 0.20rem;
}
.login_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.12rem;
}
.login_type_active {
  height: 0.56rem;
  line-height: 0.56rem;
  text-align: center;
  font-size: 0.18rem;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #666666;
  border-bottom: 0.04rem solid #dbb471;
  margin-right: 0.24rem;cursor: pointer;
}
.login_type {
  height: 0.56rem;
  line-height: 0.56rem;
  text-align: center;
  font-size: 0.18rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #666666;
  margin-right: 0.24rem;cursor: pointer;
}
.login_input {
  border-bottom: 0.01rem solid #faf9f4;
  display: flex;
  height: 0.60rem;
  align-items: center;
}
.login_quhao {
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #999999;
}
.login_line {
  width: 0.01rem;
  height: 0.40rem;
  margin-top: 0.10rem;
  background: #fafafa;
  margin: 0 0.12rem;
}
.login_inputCon {
  border: none;
  flex: 1;
  height: 0.40rem;
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #999999;
}
.login_code {
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #dbb471;
  width: 1rem;
  line-height: 0.40rem;
  text-align: center;
  cursor: pointer;
}
.login_message {
  display: flex;
  height: 0.60rem;
  align-items: center;
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ff5800;
}
.login_btn {
  width: 3.50rem;
  height: 0.36rem;
  background: linear-gradient(315deg, #dbb471, #e8ce96);
  border: 0.01rem solid rgba(0, 0, 0, 0);
  border-radius: 0.03rem;
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;cursor: pointer;
}
.login_tishi {
  font-size: 0.14rem;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #999999;
  margin-top: 0.26rem;
  padding-bottom: 0.34rem;
  border-bottom: 0.01rem solid #faf9f4;
}

.scollTop {
  position: fixed;
  bottom: 20%;
  right: 10%;
  z-index: 100;cursor: pointer;
}
.scollTop img {
  width: 0.34rem;
  height: 0.34rem;
}
.scollTop_btm{
	width: 1.89rem;
	height: 0.46rem;
	position: fixed;
	border-radius: 0.05rem;
	background: #1153a2;
	bottom: calc(20% - 0.92rem);
	right:3.5%;
	z-index: 100;
	cursor: pointer;
}

.scollTop_btm .scollTop_btm_t{
	width: 100%;
	height: 0.46rem;
	display: flex;
	align-items: center;
	font-family: "Alibaba PuHuiTi";
	// justify-content: center;
	color: #ffffff;
	position: relative;
	font-size: 0.14rem;
}
.scollTop_btm .scollTop_btm_t img{
	width: 0.17rem;
	height: 0.18rem;
	margin: 0 0.1rem;
}
.scollTop_btm .scollTop_btm_t span{
	position: absolute;
	right: 0.1rem;
}
.scollTop_btm .scollTop_btm_b{
	width: calc(100% - 0.2rem);
	height: 0.01rem;
	background: #2867b4;
	margin: 0 0.1rem;
}
.class_box{
		position: fixed;
		bottom: calc(20% - 0.92rem);
		right: calc(5% + 1.8rem);
		width: 3.6rem;
		height: 3rem;
		background: #ffffff;
		box-shadow: 0 0 0.14rem 0 #134f9721;
		border-radius: 0.1rem;
		z-index: 101;
		.title_box{
			width: 100%;
			height: 0.4rem;
			line-height: 0.4rem;
			text-align: center;
			font-family: "Alibaba PuHuiTi";
			font-size: 0.2rem;
			font-weight: 500;
			background: #1153a2;
			color: #ffffff;
			border-radius:0.1rem 0.1rem 0 0;
		}
		.class_cont{
			width: calc(100% - 0.4rem);
			height: 1.8rem;
			padding: 0.2rem;
			position: relative;
			overflow: hidden;
			overflow-y: auto;
			.class_item{
				width: 100%;
				height: 0.3rem;
				line-height: 0.3rem;
				display: flex;
				align-items: center;
				justify-content: center;
				.item_num{
					width: 0.4rem;
					height: 0.3rem;
					font-family: "Alibaba PuHuiTi";
					font-size: 0.14rem;
					font-weight: 500;
					color: #000000;
					text-align: center;
				}
				.item_text{
					width: calc(100% - 1.2rem);
					height: 0.3rem;
					margin:  0 0.1rem;
					font-family: "Alibaba PuHuiTi";
					font-size: 0.14rem;
					font-weight: 500;
					color: #000000;
					display: inline-block;
					white-space: nowrap;       /* 不换行 */
					overflow: hidden;          /* 隐藏溢出部分 */
					text-overflow: ellipsis;   /* 超出部分显示省略号 */
				}
				.item_xs{
					width: 0.4rem;
					height: 0.3rem;
					font-family: "Alibaba PuHuiTi";
					font-size: 0.14rem;
					font-weight: 500;
					color: #000000;
					text-align: center;
					margin-right: 0.01rem;
				}
				.btn_box{
					display: flex;
					align-items: center;
					width: 0.2rem;
					height: 0.3rem;
					line-height: 0.3rem;
					color: #f56c6c;
				}
			}

		}
		.class_btn{
				position: absolute;
				right: 0.1rem;
				bottom: 0.1rem;
				.btn_right{
					width: 0.76rem;
					height: 0.33rem;
					border-radius: 0.04rem;
					background: #FCC106;
					color: #ffffff;
					font-size: 0.14rem;
					font-family: Alibaba PuHuiTi;
					font-weight: 400;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #FFF;
					cursor: pointer;
				}
			}
	}
</style>



// WEBPACK FOOTER //
// src/index/index.vue